/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { GetAdminUserWalletDetailListWithSummaryRespVo } from './GetAdminUserWalletDetailListWithSummaryRespVo';
import {
    GetAdminUserWalletDetailListWithSummaryRespVoFromJSON,
    GetAdminUserWalletDetailListWithSummaryRespVoFromJSONTyped,
    GetAdminUserWalletDetailListWithSummaryRespVoToJSON,
    GetAdminUserWalletDetailListWithSummaryRespVoToJSONTyped,
} from './GetAdminUserWalletDetailListWithSummaryRespVo';

/**
 * 
 * @export
 * @interface ResponseGetAdminUserWalletDetailListWithSummaryRespVo
 */
export interface ResponseGetAdminUserWalletDetailListWithSummaryRespVo {
    /**
     * 接口状态码
     * @type {number}
     * @memberof ResponseGetAdminUserWalletDetailListWithSummaryRespVo
     */
    code?: number;
    /**
     * 接口返回消息
     * @type {string}
     * @memberof ResponseGetAdminUserWalletDetailListWithSummaryRespVo
     */
    message?: string;
    /**
     * 
     * @type {GetAdminUserWalletDetailListWithSummaryRespVo}
     * @memberof ResponseGetAdminUserWalletDetailListWithSummaryRespVo
     */
    data?: GetAdminUserWalletDetailListWithSummaryRespVo;
}

/**
 * Check if a given object implements the ResponseGetAdminUserWalletDetailListWithSummaryRespVo interface.
 */
export function instanceOfResponseGetAdminUserWalletDetailListWithSummaryRespVo(value: object): value is ResponseGetAdminUserWalletDetailListWithSummaryRespVo {
    return true;
}

export function ResponseGetAdminUserWalletDetailListWithSummaryRespVoFromJSON(json: any): ResponseGetAdminUserWalletDetailListWithSummaryRespVo {
    return ResponseGetAdminUserWalletDetailListWithSummaryRespVoFromJSONTyped(json, false);
}

export function ResponseGetAdminUserWalletDetailListWithSummaryRespVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ResponseGetAdminUserWalletDetailListWithSummaryRespVo {
    if (json == null) {
        return json;
    }
    return {
        
        'code': json['code'] == null ? undefined : json['code'],
        'message': json['message'] == null ? undefined : json['message'],
        'data': json['data'] == null ? undefined : GetAdminUserWalletDetailListWithSummaryRespVoFromJSON(json['data']),
    };
}

export function ResponseGetAdminUserWalletDetailListWithSummaryRespVoToJSON(json: any): ResponseGetAdminUserWalletDetailListWithSummaryRespVo {
    return ResponseGetAdminUserWalletDetailListWithSummaryRespVoToJSONTyped(json, false);
}

export function ResponseGetAdminUserWalletDetailListWithSummaryRespVoToJSONTyped(value?: ResponseGetAdminUserWalletDetailListWithSummaryRespVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'code': value['code'],
        'message': value['message'],
        'data': GetAdminUserWalletDetailListWithSummaryRespVoToJSON(value['data']),
    };
}

